import { render, staticRenderFns } from "./tableDocumentConfig.vue?vue&type=template&id=8dcdb4c2&"
import script from "./tableDocumentConfig.vue?vue&type=script&lang=js&"
export * from "./tableDocumentConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports